export default __webpack_public_path__ + "static/media/star-eyes.91baed68.png";